import React, { useState, useEffect } from "react";
import ModuleListAccordion from "./ModuleListAccordion";

const OrderReview = ({
  reviewDetails,
  isLoading,
  setIsLoading,
  currentRoom,
  projectSummary,
  selectionManager,
  setCurrentGroup,
  projectId,
  loadRoom,
  setIsReset,
  hoverItem,
  setHoverItem,
  isEq,
  access,
  isOrderFinalised,
}) => {
  const keys = Object.keys(reviewDetails);
  const totalKeys = keys.length;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expandedKey, setExpandedKey] = useState("height_0");
  const [moduleIds, setModuleIds] = useState([]);

  useEffect(() => {
    const currentKey = keys[currentIndex];
    const currentData = reviewDetails[currentKey];
    const { values } = currentData;

    const expandedModules = values.reduce((acc, valueObj, index) => {
      const toggleKey = `${currentKey}_${index}`;
      if (expandedKey === toggleKey && valueObj.modules) {
        acc.push(...valueObj.modules);
      }
      return acc;
    }, []);

    if (
      expandedModules.length !== moduleIds.length ||
      !expandedModules.every((val, i) => val === moduleIds[i])
    ) {
      setModuleIds(expandedModules);
    }
  }, [expandedKey, currentIndex, reviewDetails, keys]);

  const handlePrev = () => {
    if (currentIndex > 0) {
      setExpandedKey(`${keys[currentIndex - 1]}_0`);
      setModuleIds([]);
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < totalKeys - 1) {
      setExpandedKey(`${keys[currentIndex + 1]}_0`);
      setModuleIds([]);
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  const toggleExpand = (key, index) => {
    const toggleKey = `${key}_${index}`;
    setExpandedKey((prevKey) => (prevKey === toggleKey ? "" : toggleKey));
  };

  const currentKey = keys[currentIndex];
  const currentData = reviewDetails[currentKey];
  const { display_name, values } = currentData;

  return (
    <div>
      <div className="d-flex flex-column justify-content-between align-items-center border-top border-bottom p-2">
        <div className="d-flex justify-content-between align-items-center w-100">
          <i
            className="fa-solid fa-circle-arrow-left fs-5 p-2"
            onClick={handlePrev}
            style={{
              color: currentIndex === 0 ? "#CCCCCC" : "#666666",
              cursor: currentIndex === 0 ? "" : "pointer",
            }}
          ></i>

          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="fw-bold text-capitalize">{display_name}</div>
            <div style={{ color: "#AAAAAA" }}>
              {currentIndex + 1} out of {totalKeys}
            </div>
          </div>

          <i
            className="fa-solid fa-circle-arrow-right fs-5 p-2"
            onClick={handleNext}
            style={{
              color: currentIndex === totalKeys - 1 ? "#CCCCCC" : "#666666",
              cursor: currentIndex === totalKeys - 1 ? "" : "pointer",
            }}
          ></i>
        </div>
      </div>

      <div>
        <div
          style={{ display: "flex", flexWrap: "wrap" }}
          className="py-2 ms-2"
        >
          {values.map((valueObj, index) => {
            const toggleKey = `${currentKey}_${index}`;
            const isCurrentlyExpanded = expandedKey === toggleKey;

            return (
              <>
                {valueObj.value !== "remarks" &&
                  valueObj.value !== "attachments" &&
                  valueObj.value !== "" && (
                    <div key={index}>
                      <div
                        style={{
                          color: "#333",
                          borderRadius: "15px",
                          border: isCurrentlyExpanded
                            ? "1px solid #91C4ED"
                            : "1px solid transparent",
                          backgroundColor: isCurrentlyExpanded ? "#CDE1F2" : "",
                          minWidth: "50px",
                        }}
                        className="d-flex align-items-center pointer justify-content-center px-2 py-1 me-1 fs-9 fw-bold"
                        onClick={() => toggleExpand(currentKey, index)}
                      >
                        {valueObj.image && (
                          <img
                            src={valueObj.image}
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                            }}
                            className="me-1"
                          />
                        )}
                        <div>
                          {valueObj.short_name ||
                            (isNaN(parseFloat(valueObj.value))
                              ? valueObj.value
                              : `${parseFloat(valueObj.value)} mm`)}
                        </div>
                      </div>
                    </div>
                  )}
                {valueObj.value === "" && (
                  <div className="grey_letter d-flex my-4 justify-content-center align-items-center w-100">
                    {`There are no modules with ${display_name.toLowerCase()}`}
                  </div>
                )}
              </>
            );
          })}
        </div>

        <div>
          <ModuleListAccordion
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            currentRoom={currentRoom}
            projectSummary={projectSummary}
            selectionManager={selectionManager}
            setCurrentGroup={setCurrentGroup}
            projectId={projectId}
            loadRoom={loadRoom}
            setIsReset={setIsReset}
            hoverItem={hoverItem}
            setHoverItem={setHoverItem}
            isEq={isEq}
            access={access}
            isOrderFinalised={isOrderFinalised}
            moduleIds={moduleIds}
            fromOrderReview={true}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderReview;
